import $ from 'jquery';
import Cropper from 'cropperjs';

class TutorProfile {
	constructor() {
		this.setupCropper();
		this.setupSubmit();
	}

	setupSubmit() {
		const tutorProfileForm = document.getElementById('tutorProfileForm');
		const submitButton = document.getElementById('submitButton');

		// only enable submit button if the accept terms checkbox is checked
		let acceptTermsCheckbox = document.getElementById('permit');
		acceptTermsCheckbox.addEventListener('change', function (evt) {
			submitButton.disabled = (acceptTermsCheckbox.value == 'on');
		});

		tutorProfileForm.addEventListener('submit', (evt) => {
			// ;
			debugger;

			let profileImage = document.getElementById('profileImage');
			let hasProfileImageUpload = (profileImage && profileImage.files && profileImage.files[0]) ?? null;

			let existingImage = document.getElementById('ProfileImageUrl');
			if (!hasProfileImageUpload && (!existingImage || !existingImage.value)) {
				let profileImageRequired = document.getElementById('profileImageRequired');
				profileImageRequired.classList.remove('d-none');
				profileImageRequired.classList.add('d-flex');
				evt.preventDefault();
				return;
			}

			if(hasProfileImageUpload) {
				let croppedImage = document.querySelector('img[data-cropper-id="0"]');
				if (croppedImage) {
					var canvas = croppedImage.cropper.getCroppedCanvas({
						width: 300,
						height: 300
					});
					if (canvas !== null) {
						let dataUrl = canvas.toDataURL('image/png');
						let pictureBase64 = document.getElementById('pictureBase64');
						pictureBase64.value = dataUrl;
					}	
				}
			}

		});
	}
	setupCropper() {
		var cropperOptions = {
			viewMode: 1,
			aspectRatio: 1 / 1,
			strict: true,
			guides: false,
			dragMode: 'move',
			movable: true,
			highlight: true,
			dragCrop: false,
			cropBoxResizable: true,
			zoomable: true,
			data: { width: 300, height: 300 },
			autoCropArea: 0,
			minWidth: 300,
			minHeight: 300,
			maxWidth: 300,
			maxHeight: 300,
			ready: function (event) {
				this.cropper.setData({
					width: 300,
					height: 300
				});
			}
		};
		if ($('#profileImage').val() != "") {
			$('img[data-cropper-id]').each(function (i, v) {
				var $v = $(v);
				var id = $v.attr('data-cropper-id');
				var $msg = $(
					'.no-cropper-image-message[data-cropper-id=' + id + ']'
				);
				if ($v.attr('src') != null) {
					new Cropper(v, cropperOptions);
					$msg.hide();
				} else {
					$msg.show();
				}
			});
		}

		$('input[type=file][data-cropper-id]').change(function (e) {
			var $this = $(this);
			var id = $this.attr('data-cropper-id');
			var $img = $('img[data-cropper-id=' + id + ']');

			if (this.files && this.files[0]) {
				if (this.files[0].type.match(/^image\//)) {
					var reader = new FileReader();
					reader.onload = function (evt) {
						$img[0].onload = function () {
							if ($img[0].cropper != null) {
								$img[0].cropper.destroy();
							}
							new Cropper($img[0], cropperOptions);
							var $msg = $(
								'.no-cropper-image-message[data-cropper-id=' +
								id +
								']'
							);
							$msg.hide();
						};
						$img[0].src = evt.target.result;
					};
					reader.readAsDataURL(this.files[0]);
				} else {
					alert(
						'Invalid file type! Please select an image file.'
					);
				}
			} else {
				// alert('No file(s) selected.');
			}
		});

		$('#profileImage').change(function (e) {
			if (this.files.length > 0) {
				$('[data-for=PictureBase64]').removeClass('error');
				$('.profile-img').removeClass('d-none');
				$('.no-profile-img').addClass('d-none');
				$('img[data-cropper-id]').each(function (i, v) {
					var $v = $(v);
					var id = $v.attr('data-cropper-id');
					var $msg = $(
						'.no-cropper-image-message[data-cropper-id=' + id + ']'
					);
					if ($v.attr('src') != null) {
						new Cropper(v, cropperOptions);
						$msg.hide();
					} else {
						$msg.show();
					}
				});

			}

			if (e != null && e.target != null && e.target.files != null) {
				for (var file of e.target.files) {
					if (file.size > 1024 * 1024 * 5) {
						alert(
							'This file is too large. Please upload a file up to ' +
							5 +
							'MB'
						);
						$(e.target).val(null);
						return false;
					}
				}
			}
		});

	}


}
export default TutorProfile;
